import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './style.css'

export default class List extends React.Component {
  
  static propTypes = {
    items : PropTypes.array,
    itemProps : PropTypes.object,
    noItemsView : PropTypes.element,
    isSelected : PropTypes.func,
    onEvent : PropTypes.func,
    itemFactory : PropTypes.func,
    itemView : PropTypes.func,
    idKey : PropTypes.string,
    titleKey : PropTypes.string,
    subtitleKey : PropTypes.string
  }

  static defaultProps = {
    idKey : 'id',
    titleKey : 'name',
    subtitleKey : null,
    noItemsView : null,
    isSelected : null
  }

  constructor( props ) {
    super( props );
    this.onEvent = this.onEvent.bind( this );
  }

  onEvent( event, item ) {
    if ( this.props.onEvent ) {
      this.props.onEvent( event, item );
    }
  }

  createItem( item, index ) {

    const p = this.props;
    const f = p.itemFactory;
    const selected = item && this.props.isSelected ? this.props.isSelected( item ) : false;

    const props = {
      item,
      key : `item-${item[p.idKey]}-${index}`,
      onEvent : this.onEvent,
      selected,
      ...p.itemProps 
    }
    if ( f ) {
      // its a React component. Create it
      const view = f( item, props );
      if ( view ) {
        return view;
      }
    } 
    if ( this.props.itemView ) { 
      return React.createElement( p.itemView, props, null );
    }

    return ( 
      <ListItem title={p.titleKey ? item[p.titleKey] : 'Unknown'}
        subtitle={p.subtitleKey ? item[p.subtitleKey] : null}
        {...props} />
    );
  }

  render() {
    let welcome;
    const items = this.props.items || [];
    
    if ( items.length == 0 ) {
      return this.props.noItemsView;
    } 

    return ( 
      <div className={classNames( style.list, this.props.className )}>
        <div>
          { 
            items.map( ( item, index ) => { 
              return this.createItem( item, index );
            } )
          }
        </div>
      </div>
    );
  }
}
